import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import { useCallback, useState } from 'react';
import { Row } from 'reactstrap';
import { DragDropFolderCard } from './DragDropFolderCard';
import { toast } from 'react-toastify';
import DocumentsFolders from '../../../services/DocumentsFolders';
import DocumentsFoldersInterface from '../../../interfaces/DocumentsFoldersInterface';
import { FilteredOptionsInterface } from '../../../entities/FilteredOptions';
import { createOptionsPage } from '../../../entities/OptionsPaged';
import { DocumentsStateManager } from './DocumentsStateManager';

type DragDropProps = {
  documentsState: DocumentsStateManager;
};

export const DragDropFolders = ({ documentsState }: DragDropProps) => {
  const [filteredOptions] = useState({
    filters: [],
    options: createOptionsPage(documentsState.state.pageMetadata),
  });

  const hashFolderId = documentsState.state?.hash?.replace('#', '');

  const updatePositions = async (
    filteredOptions: FilteredOptionsInterface,
    idFolder: string,
    dragIndex: number,
    hoverIndex: number,
  ) => {
    if (documentsState.hasFolderEditPermission()) {
      let filterFolderIdPosition = null;
      if (hashFolderId) {
        filterFolderIdPosition = {
          field: 'documentsFoldersId',
          operation: 'hash',
          value: hashFolderId,
        };
      } else {
        filterFolderIdPosition = {
          field: 'documentsFoldersId',
          operation: 'hash',
          value: '0',
        };
      }
      const filter2 = {
        field: 'typeFile',
        operation: '=',
        value: documentsState.state.moduleTitle,
      };

      const filterSchool = {
        field: 'schoolId',
        operation: 'hash',
        value: documentsState.state?.school?.value,
      };

      const updatedFilteredOptions = {
        ...filteredOptions,
        filters: [filter2, filterFolderIdPosition, filterSchool],
      };

      const resultPositions = await DocumentsFolders(documentsState.state.token || '').listForPosition(
        updatedFilteredOptions,
      );
      const dataPositions: DocumentsFoldersInterface[] = resultPositions.data;

      const hoverIndexPosition = hoverIndex + 1;
      let countPositions = 1;
      dataPositions.map((row: any) => {
        if (row.id == idFolder) {
          handleSubmit(row.id, hoverIndexPosition);
        } else {
          if (countPositions == hoverIndexPosition) {
            countPositions = countPositions + 1;
          }
          handleSubmit(row.id, countPositions);
        }

        countPositions = countPositions + 1;
      });
    }
  };

  const handleSubmit = async (id: string, position: number) => {
    const body = {
      position: position,
    };

    try {
      if (documentsState.hasFolderEditPermission()) {
        await DocumentsFolders(documentsState.state.token || '').updatePositions(id, body);
      }
    } catch (e: any) {
      const message = String(e?.response?.data?.message || 'Create error!');
      toast.error(message);
    }
  };

  const moveCard = useCallback((dragIndex: number, hoverIndex: number, idFile: string) => {
    const updateCards = (prevCards: DocumentsFoldersInterface[]) => {
      return update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex] as DocumentsFoldersInterface],
        ],
      });
    };
    documentsState.setFoldersCards(updateCards(documentsState.state.foldersCards));
    updatePositions(filteredOptions, idFile, dragIndex, hoverIndex);
  }, []);
  const renderCard = useCallback((folder: DocumentsFoldersInterface, index: number) => {
    return (
      <DragDropFolderCard
        index={index}
        key={folder.id}
        folder={folder}
        id={folder.id}
        moveCard={moveCard}
        documentsState={documentsState}
      />
    );
  }, []);

  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <Row>{documentsState.state.foldersCards.map((folder, i) => renderCard(folder, i))}</Row>
      </DndProvider>
    </>
  );
};
